'use strict';

module.exports = {
    PROXY_REQUEST_COMMAND_VERSION: '1.5.9',
    UPLOAD_ALL_TRANSFER_LOGS_VERSION: '1.16.0'
};